import { Component, element as $, services } from '@contorion/core';
import { IVivianService } from '../../vivian/interfaces/vivian-service.interface';
import { IRecaptchaService } from '../interfaces/recaptcha-service.interface';
import { SRC_RECAPTCHA } from '../config.recapcha.confg';

export class RecaptchaComponent extends Component {
    private vivianService: IVivianService;
    private recaptchaService: IRecaptchaService;

    private get siteKey(): string {
        return this.element.dataset.sitekey;
    }

    protected get grecaptchaField(): HTMLInputElement {
        return <HTMLInputElement> $('[name="js-g-recaptcha-token"]');
    }

    private get scriptElement(): HTMLScriptElement {
        const scriptElement: HTMLScriptElement = document.createElement('script');
        scriptElement.src = `${SRC_RECAPTCHA}&render=${this.siteKey}`;

        return scriptElement;
    }

    constructor(protected element: HTMLElement) {
        super(element);

        this.init();
    }

    private async init(): Promise<void> {
        this.vivianService = await services.get('vivian-service');
        this.recaptchaService = await services.get('recaptcha-service');

        window.captchaLoadCallback = this.captchaLoadCallback.bind(this);
        window.captchaSuccessCallback = this.captchaSuccessCallback.bind(this);
        window.captchaExpiredCallback = this.captchaExpiredCallback.bind(this);
        window.captchaErrorCallback = this.captchaErrorCallback.bind(this);

        this.element.parentElement.append(this.scriptElement);
    }

    private captchaLoadCallback(): void {
        this.recaptchaService.setCaptchaLoaded();
        this.vivianService.track('lr-cap-ld', 'captcha-load');
        window?.grecaptcha.ready(() => {
            window?.grecaptcha.execute(this.siteKey, {action: 'login'}).then((token: string) => {
                // pass the token to the backend script for verification
                this.grecaptchaField.value = token;
            });
        });
    }

    private captchaSuccessCallback(): void {
        this.recaptchaService.setCaptchaSuccess();
        this.vivianService.track('lr-cap-scs', 'captcha-success');
    }

    private captchaExpiredCallback(): void {
        this.vivianService.track('lr-cap-exp', 'captcha-expired');
    }

    private captchaErrorCallback(): void {
        this.recaptchaService.setCaptchaError();
        this.vivianService.track('lr-cap-err', 'captcha-error');
    }

}
